import React from "react";

import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locals/constants";

const Component = ({ folderStatus }) => {
  const { t } = useTranslation(NAME_SPACES.HOME, {
    keyPrefix: "F003",
  });

  let contentElt;
  if (
    folderStatus.planningDay &&
    folderStatus.planningDay.date &&
    folderStatus.planningDay.intervals.length > 0
  ) {
    contentElt = (
      <p className={"content"}>
        {`${t("MESSAGE", {
          day: moment(folderStatus.planningDay.date).format("dddd D MMMM YYYY"),
          hourStart: `${moment(
            folderStatus.planningDay.intervals[0].start,
            "HH:mm:ss.SSS",
          ).format("HH:mm")}`,
          hourEnd: `${moment(
            folderStatus.planningDay.intervals[0].end,
            "HH:mm:ss.SSS",
          ).format("HH:mm")}`,
        })} `}
      </p>
    );
  } else {
    contentElt = <p className={"content"}>{`${t("NOT_PLANNED")} `}</p>;
  }

  return (
    <div>
      <p className={"smaller-title"}>{t("TITLE")}</p>
      {contentElt}
    </div>
  );
};

Component.propTypes = {
  folderStatus: PropTypes.object.isRequired,
};

export default Component;
